export const COLORS = {
  white: '#ffffff',
  black: '#000000',
  audiRed: '#bb0a30',
  audiSilver: '#b3b3b3',
  audiWarmSilver: '#b6b1a9',
  audiDarkGray: '#4a4a4a',
  audiMidGray: '#4c4c4c',
  audiGrayFive: '#f2f2f2',
};

type ColorKeys = keyof typeof COLORS;

export type Color = (typeof COLORS)[ColorKeys];
